import { usePredefinedCommentValidationContext } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/hooks/use-predefined-comment-validation-context.hook';
import {
    COMMENT_EMPTY_ERROR,
    COMMENT_TEXT_TOO_LONG_ERROR,
    initialPredefinedCommentFormValidity,
    MAX_COMMENT_LENGTH_WHEN_MARKED_AS_ERRONEOUS,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.constants';

export const usePredefinedCommentValidation = () => {
    const { validity, handleError, setApiErrors } = usePredefinedCommentValidationContext();

    const getCommentTextValidity = (value: string | null, hasAnyErroneous: boolean) => {
        if (!value || value === '') {
            return COMMENT_EMPTY_ERROR;
        }
        if (value.length > MAX_COMMENT_LENGTH_WHEN_MARKED_AS_ERRONEOUS && hasAnyErroneous) {
            return COMMENT_TEXT_TOO_LONG_ERROR;
        }

        return initialPredefinedCommentFormValidity.commentText;
    };

    return {
        validity,
        handleError,
        setApiErrors,
        getCommentTextValidity,
    };
};
